import React from 'react'
import IndustryChart from './IndustryChart'

const Sector = () => {
  return (
  <IndustryChart/>
  )
}

export default Sector